<!-- RIBA MODAL -->
<ng-container *ngIf="showRibaModalComponent">
   <div class="modal riba_free_modal" tabindex="-1" [ngClass]="{'show d-block animate-modal': isModalOpen}">
      <div class="modal-dialog modal-dialog-centered">
         <div class="modal-content">
            <button type="button" class="btn-close" (click)="closeModal()"></button>
            <div class="modal-body">
               <h3>Invest in <span>Musaffa</span></h3>
               <div class="riba_free_title">100%  Riba-Free</div>
               <p class="d-none d-lg-block">Global Halal Trading Platform</p>
               <div class="stats_grid_row">
                  <div class="stats_grid_col">
                     <h5>{{data?.total_investment_amount_full}}</h5>
                     <h6>Raised</h6>
                  </div>
   
                  <div class="stats_grid_col">
                     <h5>{{data?.total_investments | number:'1.0-0'}}</h5>
                     <h6>Investments</h6>
                  </div>
               </div>
   
               <div>
                  <p>
                     Claim up to <strong class="fw-600"><span class="text-grn">9%</span> Bonus Shares</strong> Offer Ends In
                  </p>
                  <div class="countdown-section mx-auto">
                     <div class="countdown-timer">
                        <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                           <span class="time-number fw-600 lh-1">{{ countdown.days | number : "2.0" }}</span>
                           <span class="time-label text-white text-uppercase">DAY</span>
                        </div>
                        <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                           <span class="time-number fw-600 lh-1">{{ countdown.hours | number : "2.0" }}</span>
                           <span class="time-label text-white text-uppercase">HOUR</span>
                        </div>
                        <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                           <span class="time-number fw-600 lh-1">{{ countdown.minutes | number : "2.0" }}</span>
                           <span class="time-label text-white text-uppercase">MIN</span>
                        </div>
                        <div class="time-unit d-flex flex-column align-items-center gap-1 gap-lg-2">
                           <span class="time-number fw-600 lh-1">{{ countdown.seconds | number : "2.0" }}</span>
                           <span class="time-label text-white text-uppercase">SEC</span>
                        </div>
                     </div>
                  </div>
               </div>
   
               <div class="ms-lg-auto investment-progress-wrapper">
                  <header class="d-flex align-items-center justify-content-between gap-3">
                     <h6 class="mb-0 d-flex align-items-center gap-2">
                        Growth Round
                     </h6>
                     <span class="d-block">{{data?.amount_to_be_raised}}</span>
                  </header>
                  <div class="progress rounded-pill">
                     <div class="progress-bar rounded-pill" [style.width]="data?.progressbar_percent+'%'" role="progressbar"
                        aria-valuenow="2" aria-valuemin="20" aria-valuemax="100">
                     </div>
                  </div>
   
                  <div class="d-flex align-items-end justify-content-between gap-3">
                     <span class="d-block investment-amount lh-1">
                        {{ data?.amount_received}}
                     </span>
                     <p class="mb-0 investments-count-para lh-1">
                        <span class="">{{ data?.number_of_investors | number:'1.0-0' }}</span> Investments
                     </p>
   
                  </div>
               </div>
               <a href="https://invest.musaffa.com/?utm_source=mainwebsite&utm_medium=referral&utm_campaign=cf-2025" target="_blank" rel="noopener noreferrer"
                  class="border-0 text-white text-decoration-none text-center w-100 invest-halal-btn">
                  Invest Now
               </a>
            </div>
   
         </div>
      </div>
   </div>
   
   <!-- Backdrop -->
   <div class="modal-backdrop fade show" *ngIf="isModalOpen"></div>
</ng-container>

